import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    gap: 0,
    height: "60vh",
    overflow: "hidden",
    borderRadius: 12,
  },
  formCard: {
    padding: theme.spacing(0.5, 2, 0),
    border: "none",
    backgroundColor: "var(--color-background-paper)",
    boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    minHeight: 0,
    overflow: "auto",
    scrollbarWidth: "thin",
    scrollbarColor: "#CBD5E1 transparent",
    "&::-webkit-scrollbar": {
      width: 8,
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#f1f1f1",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#CBD5E1",
      borderRadius: 4,
    },
    "&::-webkit-scrollbar-thumb:hover": {
      backgroundColor: "#94A3B8",
    },
  },
  stepperWrap: {
    // padding: theme.spacing(0, 0),
    backgroundColor: "transparent",
    "& .MuiStepper-root": {
      padding: theme.spacing(1.5, 0),
      backgroundColor: "transparent",
    },
    "& .MuiStepIcon-root": {
      color: "var(--total_row_boldbackground)",
      fontSize: 28,
      transition: "all 0.3s ease",
    },
    "& .MuiStepIcon-root.MuiStepIcon-active": {
      color: "var(--color-primary-main)",
      filter: "drop-shadow(0 2px 4px rgba(15, 23, 42, 0.25))",
    },
    "& .MuiStepIcon-root.MuiStepIcon-completed": {
      color: "var(--color-primary-main)",
    },
    "& .MuiStepLabel-label": {
      fontSize: 12,
      fontWeight: 500,
      color: "var(--color-text-secondary)",
      marginTop: 6,
      transition: "color 0.2s ease",
    },
    "& .MuiStepLabel-label.MuiStepLabel-active": {
      color: "var(--color-text-primary)",
      fontWeight: 600,
    },
    "& .MuiStepLabel-label.MuiStepLabel-completed": {
      color: "var(--color-text-secondary)",
    },
    "& .MuiStepConnector-line": {
      borderColor: "var(--total_row_boldbackground)",
      borderTopWidth: 2,
    },
    "& .MuiStepConnector-active .MuiStepConnector-line": {
      borderColor: "var(--color-primary-main)",
    },
    "& .MuiStepConnector-completed .MuiStepConnector-line": {
      borderColor: "var(--color-primary-main)",
    },
  },
  stepTitle: {
    // marginBottom: theme.spacing(1.5),
    fontSize: 16,
    fontWeight: 600,
    color: "var(--color-text-primary)",
  },
  actions: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: theme.spacing(1.5, 0),
    backgroundColor: "var(--color-background-paper)",
    borderTop: "1px solid #E2E8F0",
    marginTop: "auto",
    flexShrink: 0,
    minHeight: 52,
  },
  actionButton: {
    minWidth: "140px",
  },
  actionGroup: {
    display: "flex",
    gap: theme.spacing(1),
  },
  fieldsContainer: {
    overflowY: "auto",
    overflowX: "hidden",
    minHeight: 0,
    flex: 1,
    paddingBottom: theme.spacing(1),
    paddingRight: theme.spacing(0.5),
    "&::-webkit-scrollbar": {
      width: 5,
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "transparent",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#CBD5E1",
      borderRadius: 10,
    },
    "&::-webkit-scrollbar-thumb:hover": {
      backgroundColor: "#94A3B8",
    },
  },
  fieldGrid: {
    marginBottom: theme.spacing(1.5),
  },
  checkboxWrapper: {
    marginBottom: theme.spacing(2),
    padding: theme.spacing(1),
  },
  countFieldWrapper: {
    marginBottom: theme.spacing(2),
  },
  thirdPartyCard: {
    padding: theme.spacing(1.5),
    marginBottom: theme.spacing(1.5),
    backgroundColor: "var(--total_row_background)",
    borderRadius: 12,
    border: "1px solid #E2E8F0",
  },
  thirdPartyHeader: {
    fontSize: 13,
    fontWeight: 600,
    color: "#1E293B",
    marginBottom: theme.spacing(1),
  },
}));

export default useStyles;
